/**
 * @file util functions to help generate the response file/option.txt content.
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import { comment } from '../Utils/LinuxDataLoader';

/**
 * for specific use cases, if the content is an array: ['a', 'b', 'c'],
 * flatten it and return a string  'a;b;c;'
 * @param {String} state the state name
 * @param {Object} props an object that contains functions and variables needed
 * @return {String} return the flatten string generated from the array.
 */
const generateValueFromArray = (state, props) => {
    let array = props.getOriginState(state);
    if (typeof array === 'undefined' || array.length === 0) {
        return '';
    }
    let res = '';
    array.forEach((key, index) => {
        if (typeof key !== 'undefined' && key.length !== 0) {
            if (index > 0) {
                res = res + ';';
            }
            res = res + key;
        }
    });
    return res;
};

/**
 * Generate a string that contains all the content of the Response.ini file.
 * It contains a corner cases for Windows Custom mode.
 * @param {Object} props an Object that contains function and variable to get and set the states
 * @param {Map} winCustomState2PrefixMap  Mapping state to prefix text
 * @param {Map} winCustomState2CommentMap Mapping the comments that should appear before each prefix text
 * @return {String} a string that contains all the content of the Option.txt file.
 */
export const generateWinResponseFile = (
    props,
    winCustomState2PrefixMap,
    winCustomState2CommentMap
) => {
    let res = '';
    winCustomState2PrefixMap.forEach((value, key) => {
        let inputValue = null;
        if (
            key === 'telemetryServerRemoteNodes' ||
            key === 'serversInCluster'
        ) {
            inputValue = generateValueFromArray(key, props);
        } else {
            inputValue = props.getOriginState(key);
            if (typeof inputValue === 'boolean') {
                inputValue = inputValue ? 'TRUE' : 'FALSE';
            }
        }
        res =
            res +
            winCustomState2CommentMap.get(key) +
            value +
            inputValue +
            '\n';
    });
    return res;
};

/**
 * Generate a string that contains all the content of the Options.txt file.
 * @param {Object} props an Object that contains function and variable to get and set the states
 * @param {Map} linState2PrefixMap  Mapping state to prefix text
 * @param {Map} linState2CommentMap Mapping the comments that should appear before each prefix text
 * @return {String} a string that contains all the content of the Option.txt file.
 */
export const generateLinuxFile = (
    props,
    linState2PrefixMap,
    linState2CommentMap
) => {
    let res = '';
    linState2PrefixMap.forEach((value, key) => {
        let inputValue = null;
        if (
            key === 'telemetryServerClusterRemotenodes' ||
            key === 'servicesRegistrationServerHosts'
        ) {
            inputValue = generateValueFromArray(key, props);
        } else {
            inputValue = props.getOriginState(key);
        }
        res = res + linState2CommentMap.get(key) + value + inputValue + '\n';
    });

    if (typeof comment.guide !== 'undefined') {
        res = res + comment.guide;
    }
    return res;
};
